// @ts-ignore
 
import request from "src/lib/axios";

/** 分页查询商品 SKU 列表 GET /api/v1/product-skus */
export async function ProductSkuControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSkuControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductSkuDtoArray>(
    "/api/v1/product-skus",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建商品 SKU POST /api/v1/product-skus */
export async function ProductSkuControllerCreateV1(
  body: MyApi.CreateProductSkuDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductSkuDto>("/api/v1/product-skus", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询商品 SKU 详情（含分期套餐） GET /api/v1/product-skus/${param0} */
export async function ProductSkuControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSkuControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductSkuDto>(
    `/api/v1/product-skus/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新商品 SKU PUT /api/v1/product-skus/${param0} */
export async function ProductSkuControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSkuControllerUpdateV1Params,
  body: MyApi.UpdateProductSkuDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductSkuDto>(
    `/api/v1/product-skus/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除商品 SKU（软删除） DELETE /api/v1/product-skus/${param0} */
export async function ProductSkuControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSkuControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/product-skus/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}
